import { CommonConstants, UrlConstants } from './constants';

export const getFlockUrl = (): string => {
    if (process.env.REACT_APP_ENV === CommonConstants.ENV.PRODUCTION) {
        return UrlConstants.BASE_URL.FLOCK.PUBLISHER_ALERTS;
    }
    return UrlConstants.BASE_URL.FLOCK.SURVEY;
};
